import { useMutation } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";

export const useGetFile = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (err: unknown) => void;
}) => {
  const { getToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({ fileId }: { fileId: string }) => {
      const token = await getToken();
      const response = await authorizedAxios(token).get(
        `/export/file/${fileId}`,
        {
          responseType: "blob", // if it's a file
        }
      );
      return response;
    },
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (err) => {
      onError?.(err);
      console.error("[useGetFile] Error", err);
    },
  });

  return {
    getFile: mutation.mutate, // call with { taxYear, downloadType }
    getFileAsync: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};
